import {Grid} from '@mui/material';
import {makeStyles} from '@mui/styles';

import PieChart from './PieChart';
import Barchart from '../barChart/Barchart';
import noData from 'assets/img/noData.svg';
import PieChartLabels from './PieChartLabels';
import styles from 'assets/jss/Report/ReportStyle';
import MainAccordion from 'components/Accordion/MainAccordion';
import {NoChartData} from "./NoChartData";

const useStyles = makeStyles(styles);

const PieChartWrapper = ({selectedRangeData,patientId}) => {
    const classes = useStyles();
    return (
        <MainAccordion header='گزارش شما در نمودار' open={'panel1'}>
            <div>
                {selectedRangeData?.daysWithTest !== 0 ? (
                    <div dir='rtl'>
                        <PieChart
                            high={selectedRangeData?.highGlucoseCount}
                            low={selectedRangeData?.lowGlucoseCount}
                            inrange={selectedRangeData?.inRangeGlucoseCount}
                        />
                        <PieChartLabels  patientId={patientId}/>
                        <div style={{padding: '20px 0'}}>
                            <Barchart data={selectedRangeData?.hourlies}/>
                        </div>
                    </div>
                ) : (
                    <NoChartData/>
                )}
            </div>
        </MainAccordion>
    );
};

export default PieChartWrapper;
